import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'gold' | 'plum';
  size?: 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
const sizes: Record<NonNullable<CtaButtonProps['size']>, string> = {
  md: 'px-6 py-3.5 text-xs',
  lg: 'px-8 py-4 text-sm',
  xl: 'px-10 py-5 text-sm md:text-base'
};
const variants: Record<NonNullable<CtaButtonProps['variant']>, string> = {
  gold: 'bg-gold-500 text-ink shadow-lift hover:bg-gold-300 focus-visible:ring-gold-300',
  plum: 'bg-plum-700 text-white shadow-lift hover:bg-plum-900 focus-visible:ring-plum-300'
};
export function CtaButton({
  children,
  variant = 'gold',
  size = 'lg',
  href = '#precio',
  className = ''
}: CtaButtonProps) {
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    trackPixelEvent(isCheckout ? 'InitiateCheckout' : 'Lead', {
      content_name: 'El Puente del Adiós',
      value: 9990,
      currency: 'ARS'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-full text-center font-bold uppercase leading-tight tracking-[0.1em] transition-[transform,background-color,box-shadow,color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-4 active:translate-y-px ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-46" data-mp="35ziocjr7kesq">
      <span data-id="element-47" data-mp="3sx3tlh0mtyn1">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-x-1" aria-hidden="true" data-id="element-48" data-mp="3swap6mp5bl82" />
    </a>;
}